// Login links (welcome emails, auditor/supplier access, complaint links) carry
// credentials in the query string: ?email=…&pass=…. An inline script at the top
// of index.html strips them before Clarity loads and leaves them on
// window.__forktoLoginLinkCredentials; main.js calls this at boot to take them
// (or to strip the URL itself if that script did not run). LoginPage reads them
// from here, so analytics, error reporting and replay never see the password.
const CREDENTIAL_PARAMS = ["user", "email", "pass"];

let captured = null;

export function captureLoginLinkCredentials(win = typeof window === "undefined" ? null : window) {
    if (!win?.location || !win.history) return null;

    if (win.__forktoLoginLinkCredentials) {
        captured = win.__forktoLoginLinkCredentials;
        delete win.__forktoLoginLinkCredentials;
        return captured;
    }

    const url = new URL(win.location.href);
    if (!url.searchParams.has("pass")) return null;

    captured = {
        user: url.searchParams.get("user"),
        email: url.searchParams.get("email"),
        pass: url.searchParams.get("pass")
    };
    for (const param of CREDENTIAL_PARAMS) url.searchParams.delete(param);
    win.history.replaceState(win.history.state, "", `${url.pathname}${url.search}${url.hash}`);
    return captured;
}

export function takeLoginLinkCredentials() {
    const credentials = captured;
    captured = null;
    return credentials;
}

// Backstop for URLs recorded anywhere else (e.g. a native hash route): replace
// a password query value before it leaves the browser.
export function redactCredentialParams(value) {
    if (typeof value !== "string" || !/[?&#](pass|password)=/i.test(value)) return value;
    return value.replace(/([?&#](?:pass|password)=)[^&#]*/gi, "$1[redacted]");
}

// Redacts every string in an event payload in place. Sentry's page-load span
// keeps the original document URL (from the navigation timing entry) even after
// the address bar is cleaned, so error and tracing payloads need this too.
export function redactCredentialsDeep(value, depth = 0) {
    if (typeof value === "string") return redactCredentialParams(value);
    if (!value || typeof value !== "object" || depth > 12) return value;
    for (const [key, item] of Object.entries(value)) {
        const redacted = redactCredentialsDeep(item, depth + 1);
        if (redacted !== item) value[key] = redacted;
    }
    return value;
}
